import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import {Store} from '@ngrx/store';
import {AppState} from '../store/app.states';
import {NotificationModel} from '../model/user/NotificationModel';
import {HttpClient} from '@angular/common/http';
import {BackendApi, localhost} from '../config/backend-api';
import {ErrorDialogComponent} from '../components/user-actions/error-dialog/error-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from './auth.service';
// import * as firebase from 'firebase';

@Injectable()
export class MessagingService {

  constructor(private angularFireMessaging: AngularFireMessaging, private store: Store<AppState>,
              private httpClient: HttpClient, public dialog: MatDialog,
              private authService: AuthService) {
    this.angularFireMessaging.onTokenRefresh((token) => {
      console.log('NEW TOKEN', token);
    }).then(r => console.log('PROMISE?'));
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log(token);
        localStorage.setItem('firebase-token', token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  receiveMessage() {
    this.angularFireMessaging.onMessage((payload) => {
      console.log('onMessage callback', payload);
      this.showCustomNotification(payload);
    }).then(r => console.log('catch promise...', r));

    this.angularFireMessaging.messages.subscribe((payload: any) => {
      if (payload.notification) {
        this.showCustomNotification(payload);
      }
    });
  }

  showCustomNotification(payload: any) {
    const data = payload.data;
    const type = data.type;

    if (type === 'notifica') {
      const notifyData = payload.notification;
      const body = notifyData.body;
      const options = {
        body,
        icon: './assets/icons/icon-128x128.png',
        badge: '',
        image: ''
      };
      const notify: Notification = new Notification(notifyData.title, options);
      this.authService.pullUpdates();
      document.dispatchEvent(new CustomEvent('notification', {
        bubbles: true
      }));
    } else if (type === 'messaggio') {
      document.dispatchEvent(new CustomEvent('new-chat-message', {
        bubbles: true
      }));
    } else {
      console.log('errore notifica: ' + type);
    }
  }

  updateOnServer(notification: NotificationModel) {
    const email = JSON.parse(localStorage.getItem('user')).email;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.REMOVE_NOTIFICATION + email, notification, {responseType: 'text', observe: 'response'});
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  /*deleteToken() {
    this.angularFireMessaging.deleteToken(localStorage.getItem('firebase-token'))
      .subscribe((result) => {
        console.log('Token deleted');
        this.requestPermission();
      });
  }*/

  removeAllNotifications(email: string) {
    return this.httpClient.post(localhost + BackendApi.CLEAR_ALL_NOTIFICATIONS + email, null, {responseType: 'text', observe: 'response'});
  }

  setReadOnServer(notification: NotificationModel) {
    const email = JSON.parse(localStorage.getItem('user')).email;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.READ_NOTIFICATION + email, notification, {responseType: 'text', observe: 'response'});
  }


}
